<!--
 * @Author: wangqi angelqiqiwang@shjinjia.com.cn
 * @Date: 2024-05-23 14:21:27
 * @LastEditors: wangqi angelqiqiwang@shjinjia.com.cn
 * @LastEditTime: 2024-08-22 14:30:43
 * @FilePath: \oak\src\views\layout\components\AppMain.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <section class="app-main">

    <!-- 添加max限制防止内存泄漏，保留最近30个页面，同时只缓存指定页面，解决4GB内存泄漏 -->
    <keep-alive :max="30">
      <router-view :key="key" :height="height" />
    </keep-alive>
    <!-- </transition> -->
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.fullPath
    },
    height() {
      if (window.outerWidth < 500) {
        return window.outerHeight * 1.2
      } else {
        if (window.innerHeight < 801) {
          return window.innerHeight - 225
        } else {
          return window.innerHeight - 225
        }
      }
    }
  },
  created() {
  }
}
</script>

<style scoped>
.app-main {
  /*84 = navbar + tags-view = 50 +34 */
  min-height: calc(100vh - 94px);
  width: 100%;
  position: relative;
  overflow: hidden;
  margin: 0 !important;
}
</style>

